<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header">Export Harga Produk</div>
      <div v-if="loading == true">
        <loading></loading>
      </div>
      <div class="card-body" v-if="loading == false">
        <div class="col-lg-3">
          <b-button type="button" size="sm" variant="primary" @click="downloadfile">
            <i class="fa fa-save"></i> Download
          </b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import loading from "@/templates/Loading.vue";

export default {
  name: "report_product_price",
  components: {
    loading
  },
  data() {
    return {
      loading: false
    };
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error"
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info"
    }
  },
  methods: {
    init: function() {
      this.loading = false;
    },
    downloadfile: function() {
      if (confirm("Are You Sure?")) {
        this.loading = true;
        this.axios({
          url: "web/export/product/price/",
          method: "GET",
          responseType: "blob"
        })
          .then(response => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "product_price.xlsx");
            document.body.appendChild(link);
            link.click();
          })
          .catch(error => {
            if (error.response.status === 401) {
              this.expired(error, "");
            }
          })
          .finally(() => {
            this.loading = false;
          });

        //window.location.href = axios.defaults.baseURL+'web/export/data-customer/';
      }
    },
    expired: function(error, title) {
      if (error.response.status === 401) {
        localStorage.clear();
        this.$router.push({ path: "/login" });
        this.showErrorNotification({
          title: "Token Expired",
          message: "Your session has been expired"
        });
      } else {
        this.showErrorNotification({
          title: title,
          message: error.response.data.message
        });
      }
    }
  },
  mounted() {
    this.init();
  }
};
</script>

<style>
</style>
